
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`/commission-rates/${this.$route.query.id}`).then(res => {
        this.form = { ...res.data, partnerId: res.data.partnerId || -1 }
      })
    },
    save() {
      this.$http
        .put(`/commission-rates/${this.$route.query.id}`, {
          ...this.form,
          partnerId: this.form.partnerId === -1 ? null : this.form.partnerId
        })
        .then(() => {
          this.$router.go(-1)
        })
    },
    remove() {
      this.$http
        .delete(`/commission-rates/${this.$route.query.id}`)
        .then(() => {
          this.$router.go(-1)
        })
    }
  }
}
</script>
